import React, { useState, useEffect, useMemo } from 'react'
import classNames from 'classnames'

import classes from './drawer.module.css'
import { HeaderSearch } from '../../../../components/Header/Header'

const Drawer = ({ open, onClose, data }) => {
    const [searchText, setSearchText] = useState('')

    useEffect(() => {
        if (open) {
            window.scrollTo(0, 0)
            document.body.style.overflowY = 'hidden'
        } else {
            document.body.style.overflowY = 'auto'
        }
    }, [open])

    const filteredData = useMemo(() => {
        const trimmedText = searchText.trim().toLowerCase()

        if (trimmedText.length === 0) return data

        return data.filter(item => item.beneficiary.indexOf(searchText) !== -1)
    }, [data, searchText])

    const nth = n =>
        ['st', 'nd', 'rd'][((((n + 90) % 100) - 10) % 10) - 1] || 'th'

    const renderHeader = () => {
        return (
            <div className={classes.header}>
                <p className={classes.title}>Leaderboard</p>
                <HeaderSearch
                    placeholder="Search"
                    value={searchText}
                    onChange={searchText => setSearchText(searchText)}
                />
            </div>
        )
    }

    const renderListItem = (user, index) => {
        return (
            <div className="row d-flex justify-content-between">
                <div className="col-sm-9">
                    <div className="row">
                        <div className="col-sm-1">
                            <p className={classes.position}>{`${index + 1}${nth(
                                index + 1
                            )}`}</p>
                        </div>
                        <div className="offset-sm-1 col-sm-8">
                            <div className="d-flex">
                                <div className={classes.avatar}>
                                    {user.profilePicture && (
                                        <img
                                            src={user.profilePicture}
                                            alt="user"
                                        />
                                    )}
                                </div>
                                <div>
                                    <p className={classes.name}>
                                        {user.beneficiary}
                                    </p>
                                    <p>Time spent: {user.timeSpent}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p
                    className={classes.totalCourses}
                >{`${user.totalCompletedCourses} / ${user.totalCourses}`}</p>
            </div>
        )
    }

    const renderBody = () => {
        return (
            <div className={classes.body}>
                {filteredData?.map((item, index) =>
                    renderListItem(item, index)
                )}
            </div>
        )
    }

    return (
        <div className={classNames(classes.container, open && classes.visible)}>
            <div>
                <div className={classes.overlay} onClick={onClose} />
                <div
                    className={classNames(
                        classes.drawer,
                        open && classes.visible
                    )}
                >
                    {renderHeader()}
                    {renderBody()}
                </div>
            </div>
        </div>
    )
}

export default React.memo(Drawer)
